import type { BrandColor } from '@app-types/color'
import type { HorizontalSide } from '@app-types/styles'
import type { AuthorProps } from '@components/article-byline'
import { Image } from '@components/image'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './quote.module.scss'

/**
 * Displays a blockquote with author.
 */
export const Quote: FunctionComponent<Props> = ({
    color = 'step-cyanora',
    alignment = 'right',
    text,
    author,
    ...rest
}) => (
    <blockquote
        {...rest}
        className={classNames(styles.quote, styles[color], styles[alignment])}
    >
        {author?.avatar && (
            <Image
                className={styles.avatar}
                source={author?.avatar.source}
                source2x={author?.avatar.source2x}
                source3x={author?.avatar.source3x}
                contentType={author?.avatar.contentType}
                alt={author.name}
            />
        )}

        <div
            className={classNames(styles.text, {
                [styles['text-with-avatar']]: !!author?.avatar,
                [styles[`text-${alignment}`]]: !!author?.avatar,
                [styles['text']]: !author?.avatar,
            })}
        >
            {/* TODO: move to icons */}
            <svg
                className={classNames(styles.icon, styles[`fill-${color}`])}
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 25 20'
            >
                <path
                    d='M.34 8.947c0-2.674.922-4.936 2.716-6.53C4.388 1.13 5.567.566 8.027 0l2.255 3.908c-1.999.308-3.024.72-4.049 1.594-.922.771-1.28 1.594-1.435 3.445h5.894v10.335H.34V8.947zm13.735 0c0-2.674.922-4.936 2.664-6.53C18.123 1.13 19.302.566 21.711 0l2.255 3.908c-2 .308-3.024.72-3.998 1.594-.974.771-1.281 1.594-1.435 3.445h5.842v10.335h-10.3V8.947z'
                    fillOpacity='.5'
                />
            </svg>
            {text}
            {!author?.avatar && author?.name && (
                <div className={styles.author}>&#8212; {author.name}</div>
            )}
        </div>
    </blockquote>
)

type Props = {
    /** Author of the quote. */
    author?: AuthorProps
    text: string
    color?: BrandColor
    alignment: HorizontalSide
}
